module.exports = __webpack_public_path__ + "files/335d7d6f7156cd3c4fa1a5c1cec61a8d.png";